/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

import { IStepperLayoutProps } from './StepperLayout.interface';

const StepperLayout: React.FC<IStepperLayoutProps> = ({
    title,
    description,
    children,
    Sidebar,
    headerChildren,
    contentWrapClassName = '',
    headerClassName = '',
    childrenClassName = '',
    stepperWrapClassName = '',
}) => (
    <div className={`stepper-box-wrap ${stepperWrapClassName}`}>
        {Sidebar}
        {/* Right Content Panel */}
        <div className={`flex-1 overflow-auto scrollbar-hide bg-inherit stepper-content-wrap mb-6 ${contentWrapClassName}`}>
            {/* Step Header */}
            <div className={`sticky bg-inherit top-0 z-[3] stepper-content-header ${headerClassName}`}>
                <div className={`pb-3 border-b border-utilityGray200 w-full flex justify-between items-center gap-x-2`}>
                    <div className="">
                        <h6 className="text-grayLight900 text-base font-semibold">{title}</h6>
                        <p className="text-grayLight600 text-xs leading-[1.5] font-normal">{description}</p>
                    </div>
                    {headerChildren}
                </div>
            </div>

            <div className={`space-y-5 fade-up-animation-wrapper [&>*:not(.field-without-top-border)]:pt-5 ${childrenClassName}`}>{children}</div>
        </div>
    </div>
);

export default StepperLayout;
